"use client";

import React from "react";
import { MapPin, Phone, Globe, Facebook, Instagram, Music2, Heart, Clock, Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function RelocationAnnouncementModal() {
  return <section id="relocationannouncementmodal" className="bg-background py-16 flex justify-center items-center min-h-[50vh]">
      <div className="text-center space-y-6 max-w-2xl px-6">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground">New Location Update</h2>
        <p className="text-muted-foreground text-lg">We are officially in our new location &amp; can't wait for you to come check it out! Thank you for your continued patience &amp; support in helping us make the smoothest possible transition for your wellness journey &amp; our new move.</p>
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline" size="lg" className="font-default text-lg px-8 py-6 rounded-lg border-primary hover:bg-primary hover:text-primary-foreground transition-colors" style={{
            color: '#A89080'
          }}>2003 W. Wall St, Ste B</Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-4xl bg-background p-0 overflow-hidden border-none shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {}
              <div className="p-8 md:p-12 space-y-8 flex flex-col justify-center">
                <div className="flex justify-center md:justify-start">
                  <WvcLogo className="h-12 w-auto" />
                </div>

                <div className="space-y-2 text-center md:text-left">
                  <p className="text-sm tracking-[0.3em] uppercase text-muted-foreground font-semibold">We are officially</p>
                  <h3 className="text-5xl md:text-6xl font-serif text-color-gold-accent leading-tight">OPEN</h3>
                  <p className="text-2xl font-serif italic text-foreground">in our <Heart className="inline size-6 text-color-gold-accent fill-color-gold-accent" /> </p>
                  <h4 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground">NEW HOME</h4>
                </div>

                <div className="bg-color-gold-accent text-white py-2 px-4 rounded-lg text-[10px] md:text-xs tracking-[0.2em] font-bold flex justify-between items-center">
                  <span>MEASURE</span>
                  <span>•</span>
                  <span>OPTIMIZE</span>
                  <span>•</span>
                  <span>PERFORM</span>
                  <span>•</span>
                  <span>MAINTAIN</span>
                </div>

                <p className="text-muted-foreground text-sm leading-relaxed">
                  Visit us at our new Midland location for wellness optimization, recovery, anti-aging, gut health, weight loss support, vitamin injections, IV therapy, lab testing, and more.
                </p>

                <div className="space-y-3 bg-accent/30 p-4 rounded-lg border border-border">
                  <div className="flex items-center gap-3 text-foreground">
                    <Clock className="size-5 text-color-gold-accent" />
                    <h5 className="font-serif text-lg">Summer Hours</h5>
                  </div>
                  <div className="grid grid-cols-2 gap-2 text-xs tracking-wide">
                    <div className="text-muted-foreground uppercase">Mon - FRI</div>
                    <div className="font-bold">10:00 AM - 4:00 PM</div>
                    
                    
                    <div className="text-muted-foreground uppercase">Sat - Sun</div>
                    <div className="font-bold">Closed</div>
                  </div>
                </div>

                <div className="space-y-3 bg-foreground text-background p-4 rounded-lg shadow-md">
                  <div className="flex items-center gap-3">
                    <Star className="size-5 text-color-gold-accent fill-color-gold-accent" />
                    <h5 className="font-serif text-lg">M/O Members Only Club</h5>
                  </div>
                  <p className="text-xs leading-relaxed opacity-90">
                    Join our exclusive community for priority booking, special member pricing on all IV therapies, and monthly wellness credits.
                  </p>
                  <Button variant="outline" size="sm" className="w-full border-color-gold-accent text-color-gold-accent hover:bg-color-gold-accent hover:text-white rounded-lg text-[10px] font-bold tracking-widest" asChild>
                    <Link to="/MembershipsPage">LEARN MORE</Link>
                  </Button>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center gap-4 group">
                    <div className="bg-foreground text-background p-2 rounded-lg">
                      <MapPin className="size-5" />
                    </div>
                    <div className="flex-1 border-b border-muted pb-1">
                      <p className="text-xs font-bold tracking-widest uppercase">2003 W. Wall St, Ste B</p>
                      <p className="text-xs text-muted-foreground">MIDLAND, TX 79701</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 group">
                    <div className="bg-foreground text-background p-2 rounded-lg">
                      <Phone className="size-5" />
                    </div>
                    <div className="flex-1 border-b border-muted pb-1">
                      <p className="text-xs font-bold tracking-widest uppercase">432-247-1660</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 group">
                    <div className="bg-foreground text-background p-2 rounded-lg">
                      <Globe className="size-5" />
                    </div>
                    <div className="flex-1 border-b border-muted pb-1">
                      <p className="text-xs font-bold tracking-widest uppercase">WWW.MOPROTOCOL.COM</p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <Button className="flex-1 bg-color-gold-accent hover:bg-color-gold-accent/90 text-white rounded-lg h-12 font-bold tracking-widest" asChild>
                    <Link to="https://booking.mangomint.com/811506" newTab>BOOK NOW</Link>
                  </Button>
                  <Button variant="outline" className="flex-1 border-color-gold-accent text-foreground hover:bg-accent rounded-lg h-12 font-bold tracking-widest" asChild>
                    <Link to="/ServicesPage">VIEW SERVICES</Link>
                  </Button>
                </div>
              </div>

              {}
              <div className="hidden md:block relative min-h-[600px]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/mo protocol.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/mo protocol.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/mo protocol.png-wvc-sizes" alt="MO Protocol New Location Interior" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              </div>
            </div>

            {}
            <div className="bg-black text-white p-8 md:p-12 text-center space-y-8">
              <div className="space-y-2">
                <p className="text-xs tracking-[0.3em] uppercase font-light">Stay updated on</p>
                <h5 className="text-3xl md:text-4xl font-serif italic text-color-gold-accent">daily specials, <span className="text-white not-italic font-sans text-xl tracking-normal">new services, events,</span></h5>
                <p className="text-xs tracking-[0.3em] uppercase font-light">and wellness tips online.</p>
              </div>

              <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto">
                <Link to="https://facebook.com" className="flex flex-col items-center gap-2 group">
                  <div className="bg-white/10 p-3 rounded-lg group-hover:bg-color-gold-accent transition-colors">
                    <Facebook className="size-6" />
                  </div>
                  <span className="text-[10px] font-bold tracking-widest uppercase">Facebook</span>
                  <span className="text-[9px] text-muted-foreground">@MOPROTOCOL</span>
                </Link>
                <Link to="https://instagram.com" className="flex flex-col items-center gap-2 group">
                  <div className="bg-white/10 p-3 rounded-lg group-hover:bg-color-gold-accent transition-colors">
                    <Instagram className="size-6" />
                  </div>
                  <span className="text-[10px] font-bold tracking-widest uppercase">Instagram</span>
                  <span className="text-[9px] text-muted-foreground">@MOPROTOCOL</span>
                </Link>
                <Link to="https://tiktok.com" className="flex flex-col items-center gap-2 group">
                  <div className="bg-white/10 p-3 rounded-lg group-hover:bg-color-gold-accent transition-colors">
                    <Music2 className="size-6" />
                  </div>
                  <span className="text-[10px] font-bold tracking-widest uppercase">TikTok</span>
                  <span className="text-[9px] text-muted-foreground">@MOPROTOCOL</span>
                </Link>
              </div>

              <p className="text-sm font-serif italic text-white/80 pt-4">
                thank you for being part of our journey! <Heart className="inline size-4 text-color-gold-accent fill-color-gold-accent" />
              </p>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </section>;
}